import { render } from "./ErstInfoPop.vue?vue&type=template&id=4277c86a&scoped=true"
import script from "./ErstInfoPop.vue?vue&type=script&lang=js"
export * from "./ErstInfoPop.vue?vue&type=script&lang=js"

import "./ErstInfoPop.vue?vue&type=style&index=0&id=4277c86a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4277c86a"]])

export default __exports__